(function () {
  const BUTTON_SELECTOR = '[data-mi-cart-upsell-add]';

  function getCartAddUrl() {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return `${root}cart/add.js`;
  }

  async function addUpsellProduct(button) {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.loading === 'true') return;

    const variantId = parseInt(button.dataset.variantId || '', 10);

    const textElement = button.querySelector(
      '[data-mi-upsell-button-text]'
    );

    const originalText =
      textElement?.textContent?.trim() || 'Добави';

    if (!Number.isInteger(variantId) || variantId <= 0) {
      console.error(
        'Monkey upsell: невалиден variant ID:',
        button.dataset.variantId
      );

      if (textElement) {
        textElement.textContent = 'Грешка в продукта';
      }

      return;
    }

    button.disabled = true;
    button.dataset.loading = 'true';
    button.classList.add('is-loading');

    if (textElement) {
      textElement.textContent = 'Добавяне...';
    }

    try {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _monkey_cart_upsell: 'true',
              },
            },
          ],
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
            result.message ||
            `Cart error ${response.status}`
        );
      }

      sessionStorage.setItem(
        'mi-open-cart-after-upsell',
        'true'
      );

      window.location.reload();
    } catch (error) {
      console.error('Monkey upsell add error:', error);

      button.disabled = false;
      button.dataset.loading = 'false';
      button.classList.remove('is-loading');
      button.classList.add('has-error');

      if (textElement) {
        textElement.textContent = 'Опитайте отново';

        window.setTimeout(function () {
          textElement.textContent = originalText;
          button.classList.remove('has-error');
        }, 2500);
      }
    }
  }

  document.addEventListener('click', function (event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest(BUTTON_SELECTOR);

    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    event.stopPropagation();

    addUpsellProduct(button);
  });

  window.addEventListener('load', function () {
    const shouldOpen =
      sessionStorage.getItem(
        'mi-open-cart-after-upsell'
      ) === 'true';

    if (!shouldOpen) return;

    sessionStorage.removeItem(
      'mi-open-cart-after-upsell'
    );

    window.setTimeout(function () {
      const drawer = document.querySelector(
        'cart-drawer-component'
      );

      if (
        drawer &&
        typeof drawer.open === 'function'
      ) {
        drawer.open();
        return;
      }

      const trigger = document.querySelector(
        '[href$="/cart"], [aria-label*="Колич"], [aria-label*="cart" i]'
      );

      if (trigger instanceof HTMLElement) {
        trigger.click();
      }
    }, 600);
  });
})();